import DropdownView from './modules/dropdown-view';
import TabsView from './modules/tabs-view';
import FlyoutView from './modules/flyout-view';

jQuery(document).on('SetDesign.init', (e, SetDesign) => {
    SetDesign(($) => {
        const services = window.sdssVars?.services || false;
        if (services) {
            DropdownView(SetDesign, $);
            TabsView(SetDesign, $, services);
            FlyoutView(SetDesign, $);
        }
    });
});
